import Http from "../helpers/Http";

class AuthDataService {
  
  login(data){
    
    return Http.post("/auth/login", data)    
      .then(response => {
        if (response.data.token) {
          localStorage.setItem('boxcrusr', JSON.stringify(response.data));
        }
        return response.data;
    })
  }

  logout() {
    localStorage.removeItem('boxcrusr');
  }

}

export default new AuthDataService();